<template>
  <div class="space-y-2" @click.stop>
    <div class="grid grid-cols-2 gap-2">
      <div>
        <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Rol</label>
        <input
          v-model="editRole"
          type="text"
          class="w-full text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-1 focus:ring-blue-500"
          placeholder="Bijv. Senior Developer"
        />
      </div>
      <div>
        <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Dagen/week</label>
        <input
          v-model.number="editDpw"
          type="number"
          min="0.1"
          max="5"
          step="0.1"
          class="w-full text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-1 focus:ring-blue-500 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
        />
      </div>
    </div>
    <div class="grid grid-cols-2 gap-2">
      <div>
        <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Startdatum</label>
        <input
          v-model="editStartDate"
          type="date"
          class="w-full text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-1 focus:ring-blue-500"
        />
      </div>
      <div>
        <label class="block text-xs text-gray-500 dark:text-gray-400 mb-1">Einddatum</label>
        <input
          v-model="editEndDate"
          type="date"
          class="w-full text-sm border border-gray-300 dark:border-gray-600 rounded px-2 py-1 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-1 focus:ring-blue-500"
        />
      </div>
    </div>
    <div v-if="editError" class="text-xs text-red-600 dark:text-red-400">{{ editError }}</div>
    <div class="flex gap-1">
      <button
        @click="saveEdit"
        :disabled="isSavingEdit"
        class="text-xs px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
      >
        {{ isSavingEdit ? 'Opslaan...' : 'Opslaan' }}
      </button>
      <button
        @click="$emit('cancel')"
        :disabled="isSavingEdit"
        class="text-xs px-2 py-1 bg-gray-200 dark:bg-gray-600 dark:text-gray-200 rounded hover:bg-gray-300 dark:hover:bg-gray-500"
      >
        Annuleren
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { prospectPreferencesService } from '../../../services/prospectService.js'

const props = defineProps({
  preference: {
    type: Object,
    required: true
  },
  prospect: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['cancel', 'saved'])

function toDateString(dateString) {
  if (!dateString) return ''
  return dateString.split('T')[0]
}

const editRole = ref(props.preference.role || '')
const editDpw = ref(parseFloat(props.preference.dpw) || 1)
const editStartDate = ref(toDateString(props.preference.start_date || props.prospect?.start_date))
const editEndDate = ref(
  toDateString(props.preference.end_date || props.prospect?.expected_closing_date)
)
const isSavingEdit = ref(false)
const editError = ref('')

async function saveEdit() {
  if (!editRole.value.trim()) {
    editError.value = 'Rol is verplicht'
    return
  }
  if (!editDpw.value || editDpw.value < 0.1 || editDpw.value > 5) {
    editError.value = 'DPW moet tussen 0.1 en 5 zijn'
    return
  }
  if (editStartDate.value && editEndDate.value && editStartDate.value > editEndDate.value) {
    editError.value = 'Startdatum mag niet na einddatum liggen'
    return
  }

  isSavingEdit.value = true
  editError.value = ''

  try {
    const result = await prospectPreferencesService.update(props.prospect.id, props.preference.id, {
      role: editRole.value.trim(),
      dpw: editDpw.value,
      start_date: editStartDate.value || null,
      end_date: editEndDate.value || null
    })

    if (result.success) {
      emit('saved', result.data)
    } else {
      editError.value = result.error || 'Fout bij opslaan'
    }
  } catch (err) {
    console.error('Error updating preference:', err)
    editError.value = err.response?.data?.error || 'Fout bij opslaan'
  } finally {
    isSavingEdit.value = false
  }
}
</script>
